module.exports = __webpack_public_path__ + "static/media/IMG_7056.3bc40214.jpg";